import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useCompareValuesPerYearPerMonth } from './hooks/useCompareValuesPerYearPerMonth';

export const CompareValuesPerYearPerMonth = () => {
    const { series, subtitles } = useCompareValuesPerYearPerMonth();

    return (
        <SimpleBars
            title={`Evolução do Total do Valor Complemento Federal e Local`}
            series={series}
            subtitles={subtitles}
            height={320}
            isMoney
            showDataLabels={false}
        />
    );
};
